import { render, staticRenderFns } from "./DynamicArticleTabs.vue?vue&type=template&id=d184819a&"
import script from "./DynamicArticleTabs.vue?vue&type=script&lang=js&"
export * from "./DynamicArticleTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/buddy/magculture/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d184819a')) {
      api.createRecord('d184819a', component.options)
    } else {
      api.reload('d184819a', component.options)
    }
    module.hot.accept("./DynamicArticleTabs.vue?vue&type=template&id=d184819a&", function () {
      api.rerender('d184819a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/DynamicTabs/DynamicArticleTabs.vue"
export default component.exports